document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
    const search = gallery.querySelector('[data-media-search]');
    const count = gallery.querySelector('[data-media-count]');
    const empty = gallery.querySelector('[data-media-empty]');
    const groups = Array.from(gallery.querySelectorAll('[data-media-group]'));
    const items = Array.from(gallery.querySelectorAll('[data-media-item]'));

    if (!search) return;

    search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;

        items.forEach((item) => {
            const isMatch = item.dataset.title.toLowerCase().includes(query);
            item.hidden = !isMatch;
            if (isMatch) visible += 1;
        });

        groups.forEach((group) => {
            group.hidden = !group.querySelector('[data-media-item]:not([hidden])');
        });

        if (count) {
            const noun = visible === 1 ? count.dataset.singular : count.dataset.plural;
            count.textContent = `${visible} ${noun}`;
        }

        if (empty) empty.hidden = visible > 0;
    });

    search.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') event.preventDefault();
    });
});

const tourModal = document.getElementById('virtual-tour-modal');

if (tourModal) {
    const frame = tourModal.querySelector('[data-tour-frame]');
    const title = tourModal.querySelector('[data-tour-title]');

    tourModal.addEventListener('show.bs.modal', (event) => {
        const trigger = event.relatedTarget;
        if (!trigger) return;

        title.textContent = trigger.dataset.tourTitle;
        frame.title = `${trigger.dataset.tourTitle} 3D Tour`;
        frame.src = trigger.dataset.tourUrl;
    });

    tourModal.addEventListener('hidden.bs.modal', () => {
        frame.removeAttribute('src');
    });
}
